// @flow
import type { Dispatch } from "redux"

import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
import checkAncillaries from "booking/services/checkAncillaries/api"
import type Options from "common/records/Options"
import setMandatorySeating from "booking/services/ancillaries3rd/services/mandatorySeating/actions"
import type Journey from "common/records/Journey"
import type { PassengersValues } from "booking/services/reservation/selectors/types"
import {
  checkAncillariesLoading,
  checkAncillariesError,
} from "booking/services/ancillaries3rd/actions"

const updateAncillaries = (
  state: any,
  dispatch: Dispatch<any>,
  journey: Journey,
  passengers: PassengersValues,
  options: Options,
) => {
  if (passengers.length > 0) {
    cuckoo.track(cuckooEvents.BOOKING_CHECK_ANCILLARIES_API_TRIGGERED)
    dispatch(checkAncillariesLoading(true))

    // $FlowFixMe
    checkAncillaries(state, journey, passengers, options)
      .then(
        // $FlowFixMe
        ({ mandatory_seating: mandatorySeating }) => {
          cuckoo.track(cuckooEvents.BOOKING_CHECK_ANCILLARIES_API_SUCCESS)
          dispatch(checkAncillariesLoading(false))
          dispatch(checkAncillariesError(false))

          if (Array.isArray(mandatorySeating)) {
            dispatch(setMandatorySeating(mandatorySeating))
          }
        },
      )
      .catch(err => {
        cuckoo.track(cuckooEvents.BOOKING_CHECK_ANCILLARIES_API_ERROR, {
          error: JSON.stringify(err),
        })

        dispatch(checkAncillariesLoading(false))
        dispatch(checkAncillariesError(true))
      })
  }
}

export default updateAncillaries
